import React from 'react';
import classNames from 'clsx';
import { createSrcSet } from '@wix/fast-gallery-library';
export const DefaultImageRenderer = _ref => {
  let {
    data,
    selectors
  } = _ref;
  const imageSource = createSrcSet(data.url);
  return /*#__PURE__*/React.createElement("picture", null, /*#__PURE__*/React.createElement("source", {
    srcSet: imageSource.srcSet,
    type: `image/${imageSource.imageType}`
  }), /*#__PURE__*/React.createElement("img", {
    className: classNames('image', selectors == null ? void 0 : selectors.image),
    src: data.url,
    alt: data.title
  }));
};
//# sourceMappingURL=DefaultImageRenderer.js.map